$(document).ready(function(){
  const $checkbox = $('input[name="user[uses_head_pm_code]"]');
  const $pmCodeField = $('#PmCodeField');

  $checkbox.on('change', function () {
    if ($checkbox.is(':checked')) {
      $pmCodeField.hide();
    } else {
      $pmCodeField.show();
    }
  });
});